import alert from "./alert";

export default {
    alert,
};
